import React from 'react';
import { CircularProgress, Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { commonStyles } from '../Styles';

const useStyles = makeStyles(theme => ({
  ...commonStyles(theme),
  progressableIconLoading: {
    position: 'absolute',
  },
  progressableIcon: {},
  primaryProgress: {
    color: theme.palette.secondary.light,
    position: 'relative',
    zIndex: 10,
  },
  secondaryProgress: {
    color: theme.palette.primary.light,
    position: 'relative',
    zIndex: 10,
  },
}));

export default function InnerTabIconButton(props) {
  const {
    iconClass,
    onClick,
    onClickPromise,
    tooltip,
    color,
    disabled,
  } = props;

  const classes = useStyles();
  const IconClass = iconClass;

  const [loading, setLoading] = React.useState(false);

  return (
    <Tooltip title={tooltip} enterDelay={1000}>
      <IconButton
        color={color}
        disabled={disabled}
        onClick={(e) => {
          if (onClick) {
            onClick(e);
          }
          if (onClickPromise) {
            setLoading(true);
            onClickPromise().finally(() => setLoading(false));
          }
        }}
        style={loading ? { padding: '10px' } : {}}
      >
        <IconClass
          className={
            loading ? classes.progressableIconLoading : classes.progressableIcon
          }
        />
        {loading && (
          <CircularProgress
            className={
              color === 'primary'
                ? classes.primaryProgress
                : classes.secondaryProgress
            }
            size={28}
            thickness={6}
          />
        )}
      </IconButton>
    </Tooltip>
  );
}
